<script lang="ts">
    import { VpEmotionSadIcon } from '@decathlon-experience/icons/svelte';

    import { trans } from '$assets/shop-translator.js';
</script>

<div class="flex flex-col items-center justify-center p-xl">
    <VpEmotionSadIcon class="size-xl text-content-brand" />
    <span>{trans('search.filter.sidebar.no_result')}</span>

    <span class="text-xs"
        >{trans('search.filter.sidebar.no_result_subtitle')}</span
    >
</div>
